import { render, staticRenderFns } from "./VideoUpload.vue?vue&type=template&id=58673e68&scoped=true"
import script from "./VideoUpload.vue?vue&type=script&lang=js"
export * from "./VideoUpload.vue?vue&type=script&lang=js"
import style0 from "./VideoUpload.vue?vue&type=style&index=0&id=58673e68&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58673e68",
  null
  
)

export default component.exports